export interface AssignEcosystemAdminsPanelProps {
  expanded: boolean;
  onToggle: () => void;
}

/**
 * Realm Admin: grant/revoke ecosystem admin for a user.
 * API wiring follows — UI shell documents the intended flow.
 */
export default function AssignEcosystemAdminsPanel({
  expanded,
  onToggle,
}: AssignEcosystemAdminsPanelProps) {
  return (
    <div className="ecosystem-card admin-widget-card">
      <button type="button" className="admin-widget-header" onClick={onToggle}>
        <div className="admin-widget-header-main">
          <h3 className="ecosystem-title">Assign ecosystem admins</h3>
          <span className="admin-status-badge status-unknown">Soon</span>
        </div>
        <span className="admin-widget-toggle">{expanded ? '▾' : '▸'}</span>
      </button>
      {expanded ? (
        <div className="admin-widget-body">
          <p className="ecosystem-description">
            Look up a realm user and grant or revoke ecosystem admin for a selected ecosystem (Keycloak{' '}
            <code className="admin-inline-code">&lt;ecosystem-id&gt;-admins</code>
            ). The admin API for this flow is not wired yet — use Keycloak group membership until then.
          </p>
        </div>
      ) : null}
    </div>
  );
}
